import { gql, useQuery } from '@apollo/client';

export const GET_HOLIDAY_SUBGROUP = gql`
  query getHolidaySubGroupById($holidaySubGroupId: String!) {
    getHolidaySubGroupById(holidaySubGroupId: $holidaySubGroupId) {
      _id
      name
      createdBy
      holidays {
        name
        dateFrom
        dateTo
      }
    }
  }
`;

export const useGetHolidaySubGroupById = (holidaySubGroupId?: string) => {
  const { data, loading } = useQuery(GET_HOLIDAY_SUBGROUP, {
    variables: { holidaySubGroupId },
    skip: !holidaySubGroupId,
  });

  const holidaySubGroup = data?.getHolidaySubGroupById || {};

  return { holidaySubGroup, loading };
};
